import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { BalanceStaff } from "./BalanceStaff";
import type { BalanceTransactionDTOBase } from "./BalanceTransactionDTOBase";
import type { BalanceTransactionType } from "./BalanceTransactionType";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedModernBase } from "./TrackedModernBase";

export class BalanceTransactionStaff implements BalanceTransactionDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly transactionAmountCents: number, public readonly amountRefundedCents: number | null, public readonly balanceTransactionType: BalanceTransactionType | null, public readonly purchasableState: PurchasableState | null, public readonly transactionDateTime: Date | null, public readonly purchaseDate: Date | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly balanceId: BalanceStaff | null) {
    this.cbiServiceContext = null;
    this.balanceIdLoaded = this.balanceId != null;
    this.balanceIdCached = this.balanceId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private balanceIdLoaded: boolean;
  private balanceIdCached: BalanceStaff | null;
  async balanceIdLazy(): Promise<BalanceStaff> {
    if (!this.balanceIdLoaded) {
      this.balanceIdCached = await this.cbiServiceContext!.orderService().getBalanceTransactionStaffBalanceId(this.assignId);
      this.balanceIdLoaded = true;
    }
    return this.balanceIdCached!;
  }
}
